import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import withRouterCustom from 'utils/hoc/withRouterCustom'
import { withLaunchDarkly } from 'utils/sdks/launchDarkly.v2'
import { withMixpanel } from 'utils/sdks/mixpanel'

import { isAccountTypeBrand } from 'store/currentUser/selectors'
import { dismissTimestampedNews } from 'store/news/actions'
import {
  CREATED_BY_RETAILER_FILTER_KEY,
  RETAILER_CREATED_ORDERS_KEY,
} from 'store/news/constants'
import { createVisibleNewsSelector } from 'store/news/selectors'
import { resetSelectedOrders, sortOrders } from 'store/orderList/actions'
import * as actions from 'store/orderListFilters/actions'
import * as selectors from 'store/orderListFilters/selectors'

import { withAnalytics } from './OrderListFilters.analytics'
import OrderListFilter from './OrderListFilters.component'
import withQuery from './OrderListFilters.queries'

const newsToWatch = [
  RETAILER_CREATED_ORDERS_KEY,
  CREATED_BY_RETAILER_FILTER_KEY,
]

const visibleNewsSelector = createVisibleNewsSelector(newsToWatch)

const mapStateToProps = (state) => ({
  selectedFilters: selectors.getSelectedFilters(state),
  appliedFilters: selectors.getAppliedFilters(state),
  currentUser: state.currentUser,
  visibleNews: visibleNewsSelector(state),
  isBrandUser: isAccountTypeBrand(state),
})

const mapDispatchToProps = (dispatch) => ({
  toggleSelectFilter: (filter) => dispatch(actions.toggleSelectFilter(filter)),
  toggleDeselectAllFilters: () => dispatch(actions.toggleDeselectAllFilters()),
  handleApplySelectedFilters: () => dispatch(actions.applySelectedFilters()),
  handleSearch: (searchText) => dispatch(actions.applySearchFilter(searchText)),
  handleResetSelectedOrders: () => dispatch(resetSelectedOrders()),
  dismissTimestampedNews: (action) => dispatch(dismissTimestampedNews(action)),
  sortOrders: (payload) => dispatch(sortOrders(payload)),
})

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withRedux,
  withQuery,
  withMixpanel,
  withRouterCustom,
  withAnalytics,
  withLaunchDarkly,
)(OrderListFilter)
